import React from "react";

// Multi-select specialty chips. Stores stable ids (never labels).
export const SpecialtyPicker = ({ options = [], value = [], onChange, testIdPrefix = "specialty" }) => {
  if (!options.length) return null;
  const toggle = (id) => {
    const next = value.includes(id) ? value.filter((v) => v !== id) : [...value, id];
    onChange(next);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-picker`}>
      {options.map((o) => {
        const on = value.includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            data-testid={`${testIdPrefix}-chip-${o.id}`}
            aria-pressed={on}
            onClick={() => toggle(o.id)}
            className="rounded-full border px-3.5 py-1.5 text-xs transition-colors"
            style={{
              borderColor: on ? "var(--gf-accent)" : "var(--gf-border-strong)",
              background: on ? "var(--gf-accent)" : "transparent",
              color: on ? "var(--gf-on-accent)" : "var(--gf-text-soft)",
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default SpecialtyPicker;
